import {ChangeDetectionStrategy, Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {fromEvent, Observable, Subscription} from 'rxjs';
import {DcpActiveCartService} from '@app/services/dcp-active-cart.service';
import {DcpCartDecoratorService} from '@app/services/dcp-cart-decorator.service';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';
import {CmsComponentData, CurrentProductService, LaunchDialogService} from '@spartacus/storefront';
import {CmsFlexComponentData} from '@app/checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {SupportUrl} from '@app/checkout/checkout-support-widget/checkout-support-widget.component';
import {ConfigService, ConfiguratorUriParameterService, JsonService} from '@dcp/configurator';
import {SupportFormComponent} from '../iframe/support-form.component';
import {throttleTime} from 'rxjs/operators';
import {UserAccountFacade} from '@spartacus/user/account/root';
import {DcpProductUtilitiesService} from '@app/product/services/dcp-product-utilities.service';
import {TransactionTypeService} from '@app/services/transactionTypes/transaction-type.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {EddlFormViewEvent} from '@app/services/analytics/EDDL/events/eddl-form-view-event';
import {SUPPORT_FORM_NAME} from '@app/services/analytics/EDDL/models/eddl-adobe-tracking-data';
import {EventService} from '@spartacus/core';
import {OrderDetailsService} from '@spartacus/order/components';
import {DelegoPaymentErrorService} from '@app/payment/services/delego-rapidpay/error-handling/delego-payment-error.service';


export class SupportFormCmsData {
  url: SupportUrl;
}

@UntilDestroy()
@Component({
  selector: 'dcp-support-form-page',
  templateUrl: './support-form-page.component.html',
  styleUrls: ['./support-form-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportFormPageComponent extends SupportFormComponent implements OnInit {
  baseUrl: string;
  supportUrl: SupportUrl;
  componentData: SupportFormCmsData;
  componentData$: Observable<CmsFlexComponentData>;
  componentDataSubscription: Subscription = Subscription.EMPTY;
  mouseMove$: Observable<MouseEvent>;
  mouseMoveSubscription$: Subscription = Subscription.EMPTY;
  currentIframeContentHeight: string;

  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    userFacade: UserAccountFacade,
    activeCartService: DcpActiveCartService,
    dcpCartDecoratorService: DcpCartDecoratorService,
    orderDetailsService: OrderDetailsService,
    dcpAuthService: DcpAuthService,
    configuratorUriParameterService: ConfiguratorUriParameterService,
    configService: ConfigService,
    currentProductService: CurrentProductService,
    dcpProductUtilitiesService: DcpProductUtilitiesService,
    transactionTypeService: TransactionTypeService,
    delegoPaymentErrorService: DelegoPaymentErrorService,
    private cmsData: CmsComponentData<CmsFlexComponentData>,
    private jsonService: JsonService,
    private eventService: EventService,
    launchDialogService: LaunchDialogService
  ) {
    super(platformId, userFacade, activeCartService, dcpCartDecoratorService, orderDetailsService, dcpAuthService,
      configuratorUriParameterService, configService, currentProductService, dcpProductUtilitiesService,
      transactionTypeService, launchDialogService, delegoPaymentErrorService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.mapComponentData();
    this.listenMousemoveEvent();
    this.triggerEddlSupportFormViewEvent();
  }

  listenMousemoveEvent() {
    setTimeout(() => {
      const iframeDoc = this.iframeComponent.nativeElement.contentDocument;
      this.mouseMove$ = fromEvent<MouseEvent>(iframeDoc, 'mousemove');
      this.mouseMoveSubscription$ = this.mouseMove$.pipe(
        throttleTime(500),
        untilDestroyed(this)
      ).subscribe(() => {
        if (this.currentIframeContentHeight !== this.getIframeContentHeight()) {
          this.currentIframeContentHeight = this.getIframeContentHeight();
          this.iframeComponent.nativeElement.style.height = this.currentIframeContentHeight;
        }
      });
    });
  }

  getIframeContentHeight(): string {
    return ((this.iframeComponent?.nativeElement?.contentWindow?.document?.querySelector('dcp-root')?.scrollHeight) ?? 0) + 'px';
  }

  mapComponentData() {
    this.componentData$ = this.cmsData.data$;
    this.componentDataSubscription = this.componentData$
      .pipe(untilDestroyed(this))
      .subscribe(data => {
        this.componentData =
          this.jsonService.parseSafely(data?.classificationsProductData) as SupportFormCmsData;
        this.supportUrl = this.componentData.url;
        this.baseUrl = this.supportUrl.link;
      });
  }

  private triggerEddlSupportFormViewEvent() {
    const event = new EddlFormViewEvent();
    event.name = SUPPORT_FORM_NAME;
    setTimeout(() => this.eventService.dispatch(event));
  }
}
